import { render, staticRenderFns } from "./MyQuotationCommodityDelete.vue?vue&type=template&id=098cb715&"
import script from "./MyQuotationCommodityDelete.vue?vue&type=script&lang=js&"
export * from "./MyQuotationCommodityDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('098cb715')) {
      api.createRecord('098cb715', component.options)
    } else {
      api.reload('098cb715', component.options)
    }
    module.hot.accept("./MyQuotationCommodityDelete.vue?vue&type=template&id=098cb715&", function () {
      api.rerender('098cb715', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/App/VSL/MyQuotation/MyQuotationDetail/MyQuotationCommodity/MyQuotationCommodityDelete.vue"
export default component.exports